export const FnEditNavbar = {
  IconText: {
    icon: 'fn outline',
    gap: 'X',
    padding: 'X Z1',
    text: '{{ key }}',
    Icon: {
      // eslint-disable-next-line no-restricted-syntax -- icon glyph color, not the text (see `text:` sibling)
      color: 'inactive'
    }
  },
  EditorPositionNavbar: {
    margin: '- - - auto'
  },
  NavbarButtonSet: {
    NavbarButton_docs: {
      isActive: false,
      theme: 'transparent',
      icon: 'question mark',
      ariaLabel: (el) => el.call('polyglot', 'editor.editNavbar.openDocs'),
      // eslint-disable-next-line no-restricted-syntax -- icon-only button (aria-labelled), not visible text
      color: 'inactive',
      onClick: (ev, el) => {
        el.setWindow('docs', '/functions')
      }
    },
    NavbarButton_close: {
      icon: 'crossmark',
      ariaLabel: (el) => el.call('polyglot', 'common.action.close'),
      isActive: false,
      onClick: (ev, el) => {
        el.activateFunction(null)
      }
    }
  },
  extends: ['MicroNavbar', 'Navbar'],
  width: '100%',
  padding: 'W1 X X1'
}
